import effectManager from '../module/effect';

let effect = new effectManager();

export default class transitionManager {
    constructor(ua) {

        this.ua = ua;
        this.animationOff = Useragnt.android ? false : false;


        this.status = {
        }
        this.$darkBg = $("#p-dark-bg");
        this.status = {
            darkbg : false, /* 表示しているか */
            darkbgTimer:"",
            spCount : 0,
            spShowFlg : [],/* SP画面のみ表示したら二度と動作させない */
        }

        if(!this.animationOff){
            effect.panel($(".js__sc-show-panel"),"set");
            effect.show($(".js__sc-show"),"set");
            effect.opacity($(".js__sc-show-op"),"set");
            effect.splitText($(".js__sc-show-splittext"),"set");
            effect.bgImg($(".js__sc-show-bgimg"),"set");
            effect.scSkew($(".js__sc-show-skew"),"set");
            // effect.scSkew($(".js__sc-show-skew"),"show");
            effect.opacity(this.$darkBg,"set");
        }


    }
    show($current){

        let _this = this;

        if(this.ua==="sp"){
            if(this.status.spShowFlg[this.status.spCount]) return;
            this.status.spShowFlg[this.status.spCount] = true;
            this.status.spCount +=1;
        }

        if(this.animationOff) return;

        if($current==undefined){/* KV用 */
            effect.opacity(_this.$darkBg,"out");
        }

        let _delay = this.ua==="pc" ? 15e2 : 1e2;

        setTimeout(function () {
            if($current.find(".js__sc-show-skew")[0]){
                TweenMax.killChildTweensOf($current.find(".js__sc-show-skew"));
                effect.scSkew($current.find(".js__sc-show-skew"),"show");
            }
            if($current.find(".js__sc-show-panel")[0]){
                TweenMax.killTweensOf($current.find(".js__sc-show-panel"));
                effect.panel($current.find(".js__sc-show-panel"),"show");
            }
            if($current.find(".js__sc-show")[0]){
                TweenMax.killTweensOf($current.find(".js__sc-show"));
                effect.show($current.find(".js__sc-show"),"show");
            }
            if($current.find(".js__sc-show-op")[0]){
                TweenMax.killTweensOf($current.find(".js__sc-show-op"));
                effect.opacity($current.find(".js__sc-show-op"),"show");
            }
            if($current.find(".js__sc-show-splittext")[0]){
                TweenMax.killTweensOf($current.find(".js__sc-show-splittext >* >*"));
                effect.splitText($current.find(".js__sc-show-splittext >* >*"),"show");
            }
            if($current.find(".js__sc-show-bgimg")[0]){
                TweenMax.killTweensOf($current.find(".js__sc-show-bgimg >* >*"));
                effect.bgImg($current.find(".js__sc-show-bgimg >* >*"),"show");
            }
        },_delay);


    }
    out($prevCurrent,$current){


        let _id = $prevCurrent.attr("id");

        if(
            this.ua=="sp"&&_id!=="p-theme"&&_id!=="p-act" ||
            this.ua=="sp"&&Useragnt.android&&$current!==undefined||
            Useragnt.tablet&&_id!=="p-theme"&&_id!=="p-act"
        ) return;

        if(this.animationOff) return;

        // TweenMax.killChildTweensOf($prevCurrent);

        if($prevCurrent.find(".js__sc-show-skew")[0]){
            TweenMax.killChildTweensOf($prevCurrent.find(".js__sc-show-skew"));
            effect.scSkew($prevCurrent.find(".js__sc-show-skew"),"out");
        }
        if($prevCurrent.find(".js__sc-show")[0]){
            TweenMax.killTweensOf($prevCurrent.find(".js__sc-show"));
            effect.show($prevCurrent.find(".js__sc-show"),"out");
        }
        if($prevCurrent.find(".js__sc-show-splittext")[0]){
            TweenMax.killTweensOf($prevCurrent.find(".js__sc-show-splittext >* >*"));
            effect.splitText($prevCurrent.find(".js__sc-show-splittext >* >*"),"out");
        }
        if($prevCurrent.find(".js__sc-show-bgimg")[0]){
            TweenMax.killTweensOf($prevCurrent.find(".js__sc-show-bgimg >* >*"));
            effect.bgImg($prevCurrent.find(".js__sc-show-bgimg >* >*"),"out");
        }

        if($prevCurrent.find(".js__sc-show-panel")[0]){
            TweenMax.killTweensOf($prevCurrent.find(".js__sc-show-panel"));
            effect.panel($prevCurrent.find(".js__sc-show-panel"),"out");
        }
        if($prevCurrent.find(".js__sc-show-op")[0]){
            TweenMax.killTweensOf($prevCurrent.find(".js__sc-show-op"));
            effect.opacity($prevCurrent.find(".js__sc-show-op"),"out")
        }

        // if($current.find(".js__sc-show-op")[0]) setTimeout(()=> effect.opacity($current.find(".js__sc-show-op"),"out"),1e3)

    }
    darkbgShow(){
        this.status.darkbg = true;
        let _delay = this.ua==="pc" ? 1e2 : 1e1;
        TweenMax.killTweensOf(this.$darkBg);
        clearTimeout(this.status.darkbgTimer);
        this.status.darkbgTimer = setTimeout(()=> effect.opacity(this.$darkBg,"show"),_delay)
    }
    darkbgOut(){
        this.status.darkbg = false;

        let _delay = this.ua==="pc" ? 1e2 : 1e1;
        TweenMax.killTweensOf(this.$darkBg);
        clearTimeout(this.status.darkbgTimer);
        this.status.darkbgTimer = setTimeout(()=> effect.opacity(this.$darkBg,"out"),_delay)
    }
}